import React, { Component } from 'react';
import { connect } from 'react-redux';
import { capitalize, filter, get } from 'lodash';
import { bindActionCreators } from 'redux';
import DetailsView from '../DetailsView';
import ContactInputs from '../../../components/admin/forms/contacts/ContactInputs';
import PermissionInputs from './PermissionInputs';
import ContactShow from '../../../components/admin/forms/contacts/ContactShow';
import { MODELS } from '../../../constants/admin/settings';
import { create, update, fetchMember, fetchContactDependencies } from '../../../actions/admin/models/contacts';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';
import Tabs from '../AdminTabs';
import AdminTable from '../AdminTable';
import AdminModalForm from '../AdminModalForm';
import * as permissionsActions from '../../../actions/admin/models/permissions';
import { openModalFormWithData, openModalForm } from '../../../actions/admin/modal.forms';
import { currentUserSelector } from '../../../selectors/authentication';
import { ifPermission, PERMISSIONS, hasPermissions } from '../../../constants/authentication/permissions';
import { fetchedSelector, fetchingSelector, formDataSelector } from '../../../selectors/admin/forms';
import { transformOpenendPermission } from '../../../selectors/admin/models/permissions';
import { contextSubjectSelector } from '../../../selectors/admin/context';

class Details extends Component {
    componentDidMount() {
        this._fetchContact();
    }
    componentDidUpdate() {
        this._fetchContact();
    }
    _fetchContact() {
        if (!this.props.fetched && !this.props.fetching && get(this.props, 'match.params.contactId')) {
            this.props.fetchMember(get(this.props, 'match.params.contactId'));
        }
    }
    _transformRows = {
        function: t => capitalize(t || '').replace(/_/g, ' '),
        group: (_, v) => v.artistName || v.partnerName || v.organizationName,
        name: n => capitalize(n || '').replace(/_/g, ' '),
        eventName: en => en || 'All'
    };
    _openPermission = item => {
        if (hasPermissions(this.props.user, PERMISSIONS.PERMISSION_EDIT)) {
            this.props.openModalFormWithData(MODELS.PERMISSION, transformOpenendPermission(item));
        }
    };
    _blockPermissionInteraction = item => {
        return ifPermission(this.props.user, PERMISSIONS.GOD, false, this.props.user.contextRole.level < item.level);
    };

    _setContext = data => {
        if (this.props.contextId) {
            return filter(data, d => d.orgId === this.props.contextId);
        }
        return data;
    };
    render() {
        return (
            <Tabs
                disable={!this.props.match.params.contactId}
                labels={ifPermission(
                    this.props.user,
                    PERMISSIONS.PERMISSIONS_VIEW,
                    ['Details', 'User Permissions'],
                    ['Details']
                )}
                content={[
                    <DetailsView
                        fetchDependencies={this.props.fetchContactDependencies}
                        withShowMode={!!this.props.match.params.contactId}
                        model={MODELS.CONTACT}
                        modelId={this.props.match.params.contactId}
                        editView={ContactInputs}
                        showView={ContactShow}
                        updateAction={this.props.update}
                        createAction={this.props.create}
                    />,
                    ifPermission(
                        this.props.user,
                        PERMISSIONS.PERMISSIONS_VIEW,
                        <div>
                            <AdminTable
                                fetchDataFunction={this.props.fetchPermissions}
                                blockRowInteraction={this._blockPermissionInteraction}
                                model={MODELS.PERMISSION}
                                openItem={this._openPermission}
                                deleteAction={this.props.deletePermissions}
                                pagination={false}
                                subContextId={this.props.match.params.contactId}
                                buttonAction={this.props.openModalForm}
                                transformFunctions={this._transformRows}
                                filterFunction={this._setContext}
                            />
                            <AdminModalForm
                                title="Permission Details"
                                fetchDependencies={this.props.fetchPermissionsDependencies}
                                fields={PermissionInputs}
                                model={MODELS.PERMISSION}
                                createAction={this.props.createPermission}
                                updateAction={this.props.updatePermission}
                                modelId={this.props.match.params.contactId}
                            />
                        </div>,
                        null
                    )
                ]}
            />
        );
    }
}

const mapStateToProps = (state, props) => ({
    user: currentUserSelector(state),
    contactData: formDataSelector(state, { model: MODELS.CONTACT }),
    contextId: contextSubjectSelector(state, props),
    fetching: fetchingSelector(state),
    fetched: fetchedSelector(state)
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            ...permissionsActions,
            create,
            update,
            fetchMember,
            openModalForm,
            openModalFormWithData,
            fetchContactDependencies
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withBreadcrumb(Details, () => [BREADCRUMB.CONTACTS, BREADCRUMB.CONTACTS_FORM]));
